import { useEffect } from 'react';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';

import FacebookIcon from '@mui/icons-material/Facebook';
import { Box } from '@mui/material';

import env from '../../../env';
import { FacebookButton } from '../Button';

const FacebookLoginComponent = (props) => {
  const { loginWithFacebook, facebookButtonLabel } = props;

  const loadFbLoginApi = () => {
    window.fbAsyncInit = () => {
      window.FB?.init({
        appId: env.FB_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v14.0',
      });
    };

    ((d, s, id) => {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  };

  useEffect(() => {
    loadFbLoginApi();
  }, []);

  const handleFBLogin = () => {
    window.FB?.getLoginStatus((res) => {
      const accessToken = res?.authResponse?.accessToken;
      if (accessToken) {
        loginWithFacebook(accessToken);
      } else {
        window.FB?.login(
          (res) => {
            const accessToken = res?.authResponse?.accessToken;
            accessToken
              ? loginWithFacebook(accessToken)
              : toast.warn('Please try again');
          },
          {
            scope: 'public_profile,email',
          },
        );
      }
    });
  };

  return (
    <FacebookButton
      type="button"
      variant="contained"
      color="primary"
      disableElevation
      disableRipple
      onClick={() => handleFBLogin()}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="0.5rem"
      >
        <FacebookIcon />
        {facebookButtonLabel}
      </Box>
    </FacebookButton>
  );
};

FacebookLoginComponent.propTypes = {
  loginWithFacebook: PropTypes.func.isRequired,
  facebookButtonLabel: PropTypes.string.isRequired,
};

export default FacebookLoginComponent;
